import clsx from "clsx";
import EADialog from 'components/common/EADialog';
import i18next from 'i18next';
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';
import { Trans } from "react-i18next";
import { SecurityRatingPerformanceScores } from "services/common/SecurityRatingUtils";
import EAColorIcon from "components/common/EAColorIcon";

const SecurityRatingScoreDetailModal = ({ score, value, isOpen = false, onClose = () => { } }) => {
  const { classes } = useStyles();

  return (
    <EADialog
      isOpen={isOpen}
      maxWidth="md"
      hasActions={false}
      onClose={onClose}
      title={i18next.t("securityRating.scoreDetailModal.title", { score: i18next.t(`securityRating.scores.${score}`), interpolation: { escapeValue: false } })}
      subTitle={<span className={classes.dialogSubTitle}> {i18next.t("securityRating.scoreDetailModal.subTitle")}</span>}
    >
      <div className={classes.scoreDetailValueRisksWrapper}>
        <div className={clsx(classes.scoreDetailValueWrapper, `score-${value}`)}>
          <div className={classes.scoreDetailValueTitle}>
            {i18next.t('securityRating.scoreDetailModal.score')}
          </div>
          <div className={clsx(classes.scoreDetailValueSquare, `score-${value}`)}>
            <EAColorIcon icon="rectangle" />
            <div className={classes.scoreDetailValue}>{value}</div>
          </div>
        </div>

        <div className={classes.scoreDetailRiskWrapper}>
          <div className={classes.scoreDetailRiskTitle}>
            {i18next.t(`securityRating.scoreDetailModal.scores.${score}.riskTitle`)}
          </div>
          <div className={classes.scoreDetailRisk}>
            {i18next.t(`securityRating.scoreDetailModal.scores.${score}.risk`)}
          </div>
          <div className={classes.scoreDetailRiskExample}>
            {i18next.t(`securityRating.scoreDetailModal.scores.${score}.riskExample`)}
          </div>
        </div>
      </div>
      <div className={classes.scoreDetailTestWrapper}>
        <div className={classes.scoreDetailTestTitle}>
          {score === SecurityRatingPerformanceScores.VULNERABILITY_SNAPSHOT ?
            i18next.t('securityRating.scoreDetailModal.testsPerformed') :
            i18next.t('securityRating.scoreDetailModal.assessmentPrinciples')
          }
        </div>
        <div className={classes.scoreDetailTest}>
          {
            <Trans i18nKey={`securityRating.scoreDetailModal.scores.${score}.test`}
              components={{ strong: <b></b>, br: <br /> }}
            />
          }
        </div>
      </div>

    </EADialog>
  )
};

export default SecurityRatingScoreDetailModal;